/**
 * «Mening omborim» sahifasining MANZILDAGI holati.
 *
 * Tanlangan bo'lim manzilda turadi: `/my-warehouse?section=team`. Ilgari u
 * komponent ichida edi va sahifa yangilanganda odam har safar «Qoldiq» ga
 * qaytib tushardi — mas'ul esa kuniga o'nlab marta aynan «Xodimlar va
 * telefonlar» ga kiradi va PIN beradi.
 *
 * Buning yon foydasi: bo'limga HAVOLA berish mumkin bo'ladi («mana shu
 * yerdan PIN chiqar») va brauzerning «Orqaga» tugmasi mantiqan ishlaydi.
 *
 * Tekshiruv MAJBURIY: manzilni odam ham yozishi mumkin va noto'g'ri qiymat
 * (`?section=abc`) jimgina tashlab yuboriladi, sahifa esa yiqilmaydi.
 *
 * `requisitions-search.ts` dagi naqshning aynan o'zi. Kalit `tab` EMAS,
 * `section`: router barcha marshrutlarning qidiruv maydonlarini bitta
 * turga qo'shadi va `tab` ni «Talabnomalar» sahifasi boshqa qiymatlar
 * bilan allaqachon band qilgan.
 */

export const MY_WAREHOUSE_TABS = [
  'stock',
  'requisitions',
  'writeoffs',
  'usage',
  'team',
  'opening',
  'journal',
] as const;

export type MyWarehouseTab = (typeof MY_WAREHOUSE_TABS)[number];

/** Sahifa shu bo'limdan ochiladi — manzilda `tab` bo'lmaganda. */
export const DEFAULT_MY_WAREHOUSE_TAB: MyWarehouseTab = 'stock';

export interface MyWarehouseSearch {
  section?: MyWarehouseTab;
}

export const parseMyWarehouseSearch = (search: Record<string, unknown>): MyWarehouseSearch => {
  const raw = search['section'];
  const section =
    typeof raw === 'string' && (MY_WAREHOUSE_TABS as readonly string[]).includes(raw)
      ? (raw as MyWarehouseTab)
      : undefined;
  /* Standart qiymat manzilga YOZILMAYDI: `/my-warehouse` toza qoladi va
     eski havolalar o'zgarmaydi. */
  return section === undefined || section === DEFAULT_MY_WAREHOUSE_TAB ? {} : { section };
};
